import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';

export enum EInvoicingBannerType {
  legacy,
  warning,
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-e-invoicing-banner',
  templateUrl: './e-invoicing-banner.component.html',
  styleUrls: ['./e-invoicing-banner.component.scss'],
})
export class EInvoicingBannerComponent implements OnChanges {
  @Input() type?: EInvoicingBannerType | undefined;
  @Input() link: any[] | undefined;
  @Input() tab: string | undefined;
  @Output() close = new EventEmitter();

  public title: string;
  public subtitle: string;

  constructor(private router: Router) {
    // nada
  }

  ngOnChanges(): void {
    switch (this.type) {
      case EInvoicingBannerType.legacy:
        this.title =
          'Facturation électronique : Rappel de configuration programmé ! ';
        this.subtitle =
          "Vous ne pouvez utiliser ce mode de fonctionnement que jusqu'au 1er septembre 2027 !";
        break;
      case EInvoicingBannerType.warning:
        this.title = 'Facturation électronique : Non configurée ! ';
        this.subtitle =
          'Veuillez vous authentifier auprès de notre plate-forme agréée, depuis vos paramètres de compte !';
        break;
    }
  }

  onClose() {
    this.close?.emit();
  }

  openLink() {
    if (this.link) {
      if (this.tab) {
        this.router
          .navigate(this.link, { queryParams: { tab: this.tab } })
          .then();
      } else {
        this.router.navigate(this.link).then();
      }
    }
  }
}
